export const defaultRatioRightColumn = 0.35;
export const largeScreenRatioRightColumn = 0.4;
export const activitySidePanelRatio = 0.4;
export const getIssueContainerDefaultMaxWidth = () => 1680;
export const getIssueContainerIncreasedMaxWidth = () => 1920;
export const ACTIVITY_SIDE_PANEL_MIN_WIDTH = 400;

// These keys are needed for React's reconciliation algorithm
// to know the components are the same when changing layout.
// This stops component level state being reset on layout change.
export const FOUNDATION_CONTENT = 'FOUNDATION_CONTENT';
export const FOUNDATION_CONTEXT = 'FOUNDATION_CONTEXT';
export const QUICK_ADD_ITEMS = 'QUICK_ADD_ITEMS';
export const CONTEXT_ITEMS = 'CONTEXT_ITEMS';
export const CONTEXT_ITEMS_EXT_ID = 'issue.context-items';
export const META_CONTAINER = 'META_CONTAINER';
export const CONTENT_ITEMS = 'CONTENT_ITEMS';
export const FOOTNOTE_WRAPPER_KEY = 'FOOTNOTE_WRAPPER_KEY';
export const ACTIVITY_FEED = 'ACTIVITY_FEED';
export const ACTIVITY_FEED_EXT_ID = 'issue.activity-feed';
export const CONFIGURE_FIELDS = 'CONFIGURE_FIELDS';
